import { useGroupSuspense } from '@/features/groups/api/get-group';
import { useAuth } from '@/hooks/auth/use-auth';
import { useParams } from 'react-router-dom';

export function useSaleId(): string | undefined {
  const { context } = useAuth();

  const { saleId } = useParams();
  const { data: group } = useGroupSuspense({ groupId: context?.groupId! });

  if (saleId) {
    return saleId;
  }

  if (group.defaultSaleId) {
    return group.defaultSaleId;
  }
}
